export function relativeAgo(
  publishedAt: string | null | undefined,
): string | undefined {
  if (!publishedAt) return undefined;

  const days = Math.floor(
    (Date.now() - new Date(publishedAt).getTime()) / (1000 * 60 * 60 * 24),
  );

  if (days < 1) return 'Vandaag';
  if (days < 14) return `${days} ${days === 1 ? 'dag' : 'dagen'}`;

  const weeks = Math.floor(days / 7);
  if (weeks < 8) return `${weeks} weken`;

  const months = Math.floor(days / 30);
  return `${months} ${months === 1 ? 'maand' : 'maanden'}`;
}
